import {
  Component,
  EventEmitter,
  HostListener,
  Input,
  OnInit,
  Output,
} from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { NzUploadXHRArgs } from 'ng-zorro-antd/upload';
import { FilesService } from '../../../core/services/files.service';
import { CustomerService } from '../../../core/services/customer.service';
import { ActivatedRoute, Router } from '@angular/router';
import { NzMessageService } from 'ng-zorro-antd/message';
import { IDeactivateComponent } from '../../../core/guards/deactivate.gaurd';
import { Observable } from 'rxjs';

const CUSTOMER_FILE_UPLOAD = 'CUSTOMER_FILE_UPLOAD';

@Component({
  selector: 'app-add-edit-customer',
  templateUrl: './add-edit-customer.component.html',
  styleUrls: ['./add-edit-customer.component.scss'],
})
export class AddEditCustomerComponent implements OnInit, IDeactivateComponent {
  @Output() addEditCustomerOnChange: EventEmitter<any> = new EventEmitter();
  @Input() isVisible: boolean = false;
  customerForm: FormGroup | any;
  formErrors: any;
  passportLicenceFiles: any[] = [];
  breadcrumbs: any[] = [];
  status = 'create';
  customerId: any;
  customerData: any;
  filteredCountryData: any;
  filteredCountryDailCodeData: any;
  filteredBirthCountryData: any;
  filteredIssuedCountryData: any;
  countryData: any;
  prevPage: any;
  checked = false;
  passExists = false;
  passportLicenceUploading = false;
  submit = false;
  loading = false;
  emailExists = false;

  @HostListener('window:beforeunload', ['$event'])
  unloadNotification($event: any): string | undefined {
    const confirmationMessage =
      'You have unsaved changes. Do you really want to leave?';
    $event.returnValue = confirmationMessage; // Standard for most browsers
    return confirmationMessage; // For some older browsers
  }
  pastDateDisabled = (current: Date): boolean => {
    const today = new Date();
    const yesterday = new Date(
      today.getFullYear(),
      today.getMonth(),
      today.getDate() - 1,
    );
    return current <= yesterday;
  };

  constructor(
    private fb: FormBuilder,
    private filesService: FilesService,
    private customerService: CustomerService,
    private route: ActivatedRoute,
    private router: Router,
    private message: NzMessageService,
  ) {}

  ngOnInit(): void {
    this.uploadLoader();
    this.customerService.fetchJsonData().subscribe((data) => {
      this.countryData = data;
      this.filteredCountryData = this.countryData;
      this.filteredCountryDailCodeData = this.countryData;
      this.filteredBirthCountryData = this.countryData;
      this.filteredIssuedCountryData = this.countryData;
    });
    this.initCustomerForm();
    this.initFormErrors();
    this.passportLicenceFiles = [];
    this.route.queryParams.subscribe((params) => {
      this.prevPage = params['prev'];
    });
    this.customerId = this.route.snapshot.paramMap.get('id');
    if (this.customerId) {
      this.loading = true;
      this.customerService.getCustomerById(this.customerId).subscribe(
        (res: any) => {
          this.status = 'edit';
          this.customerData = res;
          this.passportLicenceFiles = res.passportLicenceFiles;
          this.customerForm.patchValue(this.customerData);
          this.setBreadcrumbs();
          this.loading = false;
        },
        (e: any) => {
          this.loading = false;
          this.message.create('error', 'Error');
        },
      );
    }
    this.setBreadcrumbs();
  }

  checkExisting(event: any): void {
    console.log(event);
    this.checked = true;
    this.customerService
      .getCustomerByFilter({
        filter: this.customerForm.get('passportLicenceDetails.passportNo')
          .value,
      })
      .subscribe((res) => {
        this.checked = false;
        if (res && Object.keys(res).length > 0) {
          // Passport number exists
          this.passExists = true;
          this.customerForm
            .get('passportLicenceDetails.passportNo')
            .setErrors({ exists: true });
        } else {
          // Passport number does not exist
          this.passExists = false;
          this.customerForm
            .get('passportLicenceDetails.passportNo')
            .setErrors(null);
        }
      });
  }
  uploadLoader() {
    this.filesService.fileUploadingSubject.subscribe((res: any) => {
      switch (res.type) {
        case CUSTOMER_FILE_UPLOAD:
          this.passportLicenceUploading = res.loading;
          break;
      }
    });
  }

  initCustomerForm(): void {
    this.customerForm = this.fb.group({
      renterDetails: this.fb.group({
        fullName: [
          null,
          [
            Validators.required,
            Validators.maxLength(70),
            Validators.pattern(/^[a-zA-Z\s]*$/),
          ],
        ],
        title: [null, [Validators.required]],
        email: [null, [Validators.maxLength(100), Validators.email]],
        contactNo: [
          null,
          [
            Validators.required,
            Validators.maxLength(15),
            Validators.pattern(/^\d+$/),
          ],
        ],
        dailCode: [null, [Validators.required]],
        homeAddress: [null],
        homeCountry: [null, Validators.required],
        otherCountry: [null],
        dob: [null],
        birthCity: [null],
        birthCountry: [null],
      }),
      passportLicenceDetails: this.fb.group({
        passportNo: [null],
        issueDatePass: [null],
        expiryDatePass: [null],
        drivingLicenceNo: [null],
        issueDateLicence: [null],
        expiryDateLicence: [null],
        issuedCountryLicence: [null],
      }),
    });
  }

  initFormErrors() {
    this.formErrors = {
      renterDetails: this.fb.group({
        fullName: {},
        contactNo: {},
        homeAddress: {},
        homeCountry: {},
        otherCountry: {},
        dob: {},
        birthCity: {},
        birthCountry: {},
      }),
      passportLicenceDetails: this.fb.group({
        passportNo: {},
        issueDatePass: {},
        expiryDatePass: {},
        drivingLicenceNo: {},
        issueDateLicence: {},
        expiryDateLicence: {},
      }),
    };
  }

  setBreadcrumbs(): void {
    if (this.status === 'edit') {
      this.breadcrumbs = [
        {
          title: ` Customer `,
          route: '/admin/customers',
          icon: 'delivered-procedure',
        },
        {
          title: ` Edit Customer`,
        },
      ];
    } else {
      this.breadcrumbs = [
        {
          title: ` Customer `,
          route: '/admin/customers',
          icon: 'delivered-procedure',
        },
        {
          title: ` Add Customer`,
        },
      ];
    }
  }

  // onSubmit(): void {
  //   if (this.customerForm.valid) {
  //     this.customerService
  //       .getCustomerByEmail({
  //         email: this.customerForm.get('renterDetails.email').value,
  //       })
  //       .subscribe(
  //         (res: any) => {
  //           if (res) {
  //             this.message.create('warning', `Email is already existing!`);
  //             this.emailExists = true;
  //           } else {
  //             this.emailExists = false;
  //             this.customerService
  //               .createCustomer({
  //                 ...this.customerForm.value,
  //                 passportLicenceFiles: this.passportLicenceFiles,
  //               })
  //               .subscribe(
  //                 () => {
  //                   this.submit = true;
  //                   this.message.create(
  //                     'success',
  //                     `New Customer has been added!`,
  //                   );
  //                   this.router.navigate(['/admin/customers']);
  //                 },
  //                 (e: any) => {
  //                   this.message.create('error', 'Error');
  //                 },
  //               );
  //           }
  //         },
  //         (e: any) => {
  //           this.message.create('error', 'Error');
  //         },
  //       );
  //   } else {
  //     this.markFormGroupAsTouched(this.customerForm);
  //   }
  // }
  // onSubmit(): void {
  //   const emailControl = this.customerForm.get('renterDetails.email');
  //
  //   // Check if the email is empty
  //   if (!emailControl.value) {
  //     this.submitForm();
  //   } else {
  //     this.customerService
  //       .getCustomerByEmail({
  //         email: emailControl.value,
  //       })
  //       .subscribe(
  //         (res: any) => {
  //           if (res) {
  //             this.message.create('warning', `Email is already existing!`);
  //           } else { this.message.create('success', `New Customer has been added!`);
  //             this.router.navigate(['/admin/customers']);
  //             this.submitForm();
  //           }
  //         },
  //         (e: any) => {
  //           this.message.create('error', 'Error');
  //         },
  //       );
  //   }
  // }

  // Extracted method to handle form submission
  //   private submitForm(): void {
  //     this.customerService
  //       .createCustomer({
  //         ...this.customerForm.value,
  //         passportLicenceFiles: this.passportLicenceFiles,
  //       })
  //       .subscribe(
  //         () => {
  //           this.customerForm.reset();
  //           this.passportLicenceFiles = [];
  //           this.isVisible = false;
  //           this.addEditCustomerOnChange.emit({
  //             name: 'created',
  //             value: false,
  //           });
  //         },
  //         (e: any) => {
  //           this.message.create('error', 'Error');
  //         },
  //       );
  //   }

  onSubmit(): void {
    const emailControl = this.customerForm.get('renterDetails.email');

    // Check if the email is empty
    if (!emailControl.value) {
      this.submitForm();
    } else {
      this.customerService
        .getCustomerByEmail({
          email: emailControl.value,
        })
        .subscribe(
          (res: any) => {
            if (res) {
              this.message.create('warning', `Email is already existing!`);
            } else {
              this.submitForm();
            }
          },
          (e: any) => {
            this.message.create('error', 'Error');
          },
        );
    }
  }

  // Extracted method to handle form submission
  private submitForm(): void {
    this.customerService
      .createCustomer({
        ...this.customerForm.value,
        passportLicenceFiles: this.passportLicenceFiles,
      })
      .subscribe(
        () => {
          this.customerForm.reset();
          this.passportLicenceFiles = [];
          this.isVisible = false;
          this.addEditCustomerOnChange.emit({
            name: 'created',
            value: false,
          });
          this.message.create('success', `New Customer has been added!`);
          this.router.navigate(['/admin/customers']);
        },
        (e: any) => {
          this.message.create('error', 'Error');
        },
      );
  }

  markFormGroupAsTouched(formGroup: FormGroup): void {
    Object.values(formGroup.controls).forEach((control: any) => {
      control.markAsTouched();

      if (control instanceof FormGroup) {
        this.markFormGroupAsTouched(control);
      }
    });
  }

  onUpdate(): void {
    if (this.customerForm.valid) {
      // Check if the email is empty
      if (!this.customerForm.get('renterDetails.email').value) {
        this.updateCustomer();
      } else {
        this.customerService
          .getCustomerByEmail({
            email: this.customerForm.get('renterDetails.email').value,
          })
          .subscribe((res: any) => {
            if (
              res &&
              res.renterDetails.email !== this.customerData.renterDetails.email
            ) {
              this.message.create('warning', `Email is already existing!`);
              this.emailExists = true;
            } else {
              this.emailExists = false;
              this.updateCustomer();
            }
          });
      }
    } else {
      this.markFormGroupAsTouched(this.customerForm);
    }
  }
  updateCustomer() {
    this.customerService
      .updateCustomer({
        _id: this.customerId,
        ...this.customerForm.value,
        passportLicenceFiles: this.passportLicenceFiles,
      })
      .subscribe(
        (resp: any) => {
          this.message.create(
            'success',
            'Customer has been updated successfully!',
          );
          if (this.prevPage) {
            this.submit = true;
            this.router.navigate([`/admin/customers/${this.customerId}`]);
          } else {
            this.submit = true;
            this.router.navigate(['/admin/customers']);
          }
        },
        (e: any) => {
          this.message.create('error', 'Error');
        },
      );
  }

  upload = (item: NzUploadXHRArgs) =>
    this.filesService
      .postFile(item.file, CUSTOMER_FILE_UPLOAD)
      .subscribe((res) => {
        this.message.create('success', `Attachment has been uploaded!`);
        const data = res as any;
        this.passportLicenceFiles.push({ name: item.file.name, url: data.url });
        this.filesService.fileUploadingSubject.next({
          type: CUSTOMER_FILE_UPLOAD,
          loading: false,
        });
      });

  confirmRemoveAttachment(attachmentId: any): void {
    this.message.create('success', `Attachment has been deleted!`);
    this.passportLicenceFiles.splice(attachmentId, 1);
  }

  confirm(): void {
    if (this.prevPage) {
      this.router.navigate([`/admin/customers/${this.customerId}`]);
    } else {
      this.router.navigate(['/admin/customers']);
    }
  }

  canExit(): Observable<boolean> | Promise<boolean> | boolean {
    if (this.submit) {
      return true;
    } else if (this.customerForm.dirty || this.customerForm.touched) {
      return confirm(
        ' You have unsaved changes, Do you really want to discard these changes?',
      );
    } else {
      return true;
    }
  }

  onSearchHomeCountry(searchValue: string): void {
    if (searchValue) {
      // Filter the country data based on the search value
      this.filteredCountryData = this.countryData.filter(
        (country: { name: string }) =>
          country.name.toLowerCase().includes(searchValue.toLowerCase()),
      );
    } else {
      // If the search value is empty, show all countries
      this.filteredCountryData = this.countryData;
    }
  }

  onSearchBirthCountry(searchValue: string): void {
    if (searchValue) {
      // Filter the country data based on the search value
      this.filteredBirthCountryData = this.countryData.filter(
        (country: { name: string }) =>
          country.name.toLowerCase().includes(searchValue.toLowerCase()),
      );
    } else {
      // If the search value is empty, show all countries
      this.filteredBirthCountryData = this.countryData;
    }
  }

  onSearchIssuedCountry(searchValue: string): void {
    if (searchValue) {
      // Filter the country data based on the search value
      this.filteredIssuedCountryData = this.countryData.filter(
        (country: { name: string }) =>
          country.name.toLowerCase().includes(searchValue.toLowerCase()),
      );
    } else {
      // If the search value is empty, show all countries
      this.filteredIssuedCountryData = this.countryData;
    }
  }
  onSearchDailCode(searchValue: string): void {
    if (searchValue) {
      // Filter the country data based on the search value
      this.filteredCountryDailCodeData = this.countryData.filter(
        (country: { dial_code: string }) =>
          country.dial_code.toLowerCase().includes(searchValue.toLowerCase()),
      );
    } else {
      // If the search value is empty, show all countries
      this.filteredCountryDailCodeData = this.countryData;
    }
  }
}
